module.exports = __webpack_public_path__ + "static/media/img01.d21e2be0.webp";